import { useState } from "react";
import { useT } from "../../lib/i18n.js";
import { errorMessage, trpcClient } from "../../lib/trpc.js";
import { Button } from "../../components/ui/Button.js";
import { Field } from "../../components/ui/Field.js";
import { Input } from "../../components/ui/Input.js";

export function EmailRecoveryForm() {
  const t = useT();
  const [username, setUsername] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return <form className="fc-recovery__form" onSubmit={event => { event.preventDefault(); setBusy(true); setError(null);
    void trpcClient.emailRecovery.request.mutate({ username }).then(() => setSent(true)).catch(cause => setError(errorMessage(cause))).finally(() => setBusy(false));
  }}>
    <p>{t("Reset your password by email without waiting for a group member. This restores sign-in only; your old group photos stay locked until you restore their keys.")}</p>
    <p>{t("Email recovery must already be enabled for your account. A recovery file or an unlocked device can preserve access to your existing photos instead.")}</p>
    <Field label={t("Username or email")} required><Input value={username} autoComplete="username" disabled={busy} onChange={event => { setUsername(event.target.value); setSent(false); }} required /></Field>
    <Button type="submit" variant="primary" loading={busy}>{t("Send password reset link")}</Button>
    {sent && <p role="status">{t("If this account has email recovery enabled, a reset link has been sent to its protected recovery address. Check your inbox and spam folder. The link lasts 15 minutes.")}</p>}
    {error && <p role="alert" className="fc-auth__error">{error}</p>}
  </form>;
}
